import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    reportsPage_settingEmail: 'Настройка почты',
    reportsPage_emailColumn:'Почта',
    reportsPage_deleteEmailModal:'Удаление',
    reportsPage_deleteEmailConfirmText:'Вы уверены, что хотите удалить почту?',
    reportsPage_deleteEmailBtn:'Удалить',
    reportsPage_actionsColumn:'Действие',
    reportsPage_addEmail:'Добавить',
    reportsPage_addEmailModal:'Добавить почту',
    reportsPage_emailLabel: "Email",
    reportsPage_cancelBtn: "Отмена",
    reportsPage_saveBtn: "Сохранить",
    reportsPage_addEmailError: "Ошибка при добавлении Email",
    reportsPage_emailRequired: "Пожалуйста, введите email",
    reportsPage_emailInvalid: "Введите корректный email",
    reportsPage_registryReport:'Реестр отчетов',
    reportsPage_registryCreatedDateColumn:'Дата и время формирования отчёта',
    reportsPage_registryReportPeriod:'Отчётный период',
    reportsPage_errorLoadEmailList:'Не удалось получить список адресов электронной почты',
    reportsPage_errorDeleteEmail:'Не удалось удалить электронную почту',
    reportsPage_errorAddEmail:'Не удалось добавить электронную почту'
  },
  kk: {
    reportsPage_settingEmail: 'Поштаны баптау',
    reportsPage_emailColumn: 'Пошта',
    reportsPage_deleteEmailModal: 'Жою',
    reportsPage_deleteEmailConfirmText: 'Поштаны жоюға сенімдісіз бе?',
    reportsPage_deleteEmailBtn: 'Жою',
    reportsPage_actionsColumn: 'Әрекет',
    reportsPage_addEmail: 'Қосу',
    reportsPage_addEmailModal: 'Поштаны қосу',
    reportsPage_emailLabel: 'Email',
    reportsPage_cancelBtn: 'Бас тарту',
    reportsPage_saveBtn: 'Сақтау',
    reportsPage_addEmailError: 'Email қосу кезінде қате пайда болды',
    reportsPage_emailRequired: 'Поштаны енгізіңіз',
    reportsPage_emailInvalid: 'Дұрыс email енгізіңіз',
    reportsPage_registryReport: 'Есептер тізілімі',
    reportsPage_registryCreatedDateColumn: 'Есептің құрылу күні мен уақыты',
    reportsPage_registryReportPeriod: 'Есеп беру кезеңі',
    reportsPage_errorLoadEmailList: 'Пошталар тізімін алу мүмкін болмады',
    reportsPage_errorDeleteEmail: 'Поштаны жою мүмкін болмады',
    reportsPage_errorAddEmail: 'Поштаны қосу мүмкін болмады'


  }
});
